<template>
    <v-container>
        <v-label>{{$t('feature.edit')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('feature.name')"
                                  :placeholder="$t('feature.name')"
                                  v-model="feature.name"
                                  :rules="nameRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('feature.feature_id')"
                                  :placeholder="$t('feature.feature_id')"
                                  v-model="feature.feature_id"
                                  :rules="featureIdRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-file-input accept="image/*"
                                :label="$t('feature.default_icon')"
                                v-model="feature.default_icon"
                                :rules="defaultIconRules">
                        <template v-slot:selection="{file}">
                            <v-img :src="getFileUrl(file)"
                                max-width="250px"
                                max-height="250px"></v-img>
                        </template>
                    </v-file-input>
                </v-row>
            </v-container>
        </v-form>
        <v-row>
            <v-col>
                <v-btn color="primary" @click="saveFeature" :disabled="!isFormValid">
                    {{$t('save')}}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useGet} from "feathers-vuex";

    export default {
        name: 'FeatureAdd',
        setup(props, {root}) {
            const {Feature} = root.$FeathersVuex.api;

            const featureId = computed(() => root.$route.params.featureId);
            const {item: feature, isPending} = useGet({model: Feature, id: featureId});

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const featureIdRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const defaultIconRules = ref([
                value => !!value || 'Required',
            ]);
            const saveFeature = async () => {
                try {
                    if (feature.value.default_icon instanceof File) {
                        feature.value.default_icon = {src: await root.$uploadFile(feature.value.default_icon)};
                    }
                    if (!feature.value.default_icon) {
                        feature.value.default_icon = null;
                    }

                    feature.value.save().then(() => {
                        root.$router.replace({name: 'feature-list'});
                        root.$store.dispatch('showSnackBar', root.$t('feature.save_successful'));
                    }, root.$handleFeatherError.bind(root));
                } catch (e) {
                    root.$handleFeatherError(e);
                }
            };

            return {
                feature,
                nameRules,
                featureIdRules,
                defaultIconRules,
                isFormValid,
                saveFeature,
                getFileUrl: root.$getFileURL,
            }
        },
    }
</script>